﻿export class NamedValueResponse {
    constructor(public id: number, public name: string) {  }
}